import { render, staticRenderFns } from "./TrackMetadataTab.vue?vue&type=template&id=6c1a4188&scoped=true"
import script from "./TrackMetadataTab.vue?vue&type=script&lang=js"
export * from "./TrackMetadataTab.vue?vue&type=script&lang=js"
import style0 from "./TrackMetadataTab.vue?vue&type=style&index=0&id=6c1a4188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1a4188",
  null
  
)

export default component.exports